import { useCallback, useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import useShowingExitConfirmation from './useShowingExitConfirmation';
import { getParentOrigin } from '../utils/post-message';
// Listen for `go_back` events sent from mobile SDKs whenever the OS-level
// back button is pressed. The behavior is:
//  - if it's possible to go back in Link, go back
//  - if Link's back button is hidden, show the exit confirmation
//  - if the exit confirmation is already shown, exit
export var useGoBackEventListener = function (_a) {
    var isBackable = _a.isBackable, handleBack = _a.handleBack, handleExitConfirmation = _a.handleExitConfirmation, handleExit = _a.handleExit;
    var showingExitConfirmation = useShowingExitConfirmation().showingExitConfirmation;
    var goBackEventListener = useCallback(function (event) {
        if (!event.data)
            return;
        if (typeof event.data !== 'object')
            return;
        var dataType = event.data.type;
        var eventName = 'eventName' in event.data ? event.data.eventName : null;
        var parentOrigin = getParentOrigin();
        if (dataType === 'PINWHEEL_INTERNAL_COMM_DOWN' &&
            eventName === 'go_back') {
            if (parentOrigin && event.origin !== parentOrigin) {
                datadogLogs.logger.warn("Link received 'go_back' event from an untrusted origin (".concat(event.origin, ")"));
                return;
            }
            if (isBackable) {
                handleBack();
            }
            else if (!showingExitConfirmation) {
                handleExitConfirmation();
            }
            else {
                handleExit();
            }
        }
    }, [
        handleExit,
        handleBack,
        handleExitConfirmation,
        isBackable,
        showingExitConfirmation,
    ]);
    useEffect(function () {
        window.addEventListener('message', goBackEventListener);
        return function () { return window.removeEventListener('message', goBackEventListener); };
    }, [goBackEventListener]);
};
